export const DepthFormat = [
    'D_RGB',
    'D_DEPTH'
];
export default DepthFormat;
